<template>
    <div class="item slideRight" :class="[{ w_picture: item.image && item.num_progress == 0, w_progress: !item.image && item.num_progress > 0, extended: item.image && item.num_progress > 0 }, $mq]" @click="sendedId(item.id)">
        <div class="list">
            <template v-if="!auditsNoPhoto">
                <div v-if="item.image" class="picture" :style="{ backgroundImage: 'url(' + item.image + ')', backgroundSize: 'cover' }"></div>
                <!-- <cld-image class="picture" v-if="item.image" :publicId="item.image" type="fetch" loading="lazy" :style="{ backgroundSize: 'cover' }">
                    <cld-transformation height="300" crop="fill" fetchFormat="webp" />
                </cld-image> -->
                <div v-else class="picture"></div>
            </template>
            <h6 class="name">
                <span class="name-text">{{ item.name }}</span>
            </h6>
            <div class="progress" v-if="showProgressTag || actionPlansBadge">
                <InfoQuantityTag v-if="showProgressTag" icon="i-andy-time-active" :label="item.num_progress > 1 ? 'audit.num_progress_pl' : 'audit.num_progress_sg'" :value="Number(item.num_progress)" textColor="#2c52c4" backgroundColor="#eaeef9" />
                <InfoQuantityTag v-if="actionPlansBadge" :icon="actionPlansBadge.icon" :label="actionPlansBadge.label" :value="actionPlansBadge.value" :textColor="actionPlansBadge.textColor" :backgroundColor="actionPlansBadge.backgroundColor" />
            </div>
        </div>
        <!-- <div class="nav" v-if="['landscape', 'desktop'].includes($mq)"></div> -->
    </div>
</template>
<script>
import InfoQuantityTag from '@/components/domain/ui/InfoQuantityTag.vue'

export default {
    components: {
        InfoQuantityTag
    },
    props: {
        item: { type: Object },
        auditsNoPhoto: { type: Boolean }
    },
    data() {
        return {}
    },
    computed: {
        showProgressTag() {
            return Number(this.item && this.item.num_progress) > 0
        },
        openActionPlansByAuditTemplate() {
            return this.$store.getters['actionplan/getOpenActionPlansByAuditTemplate']
        },
        openActionPlansCount() {
            const auditTemplateId = this.item && this.item.id

            if (!auditTemplateId) {
                return 0
            }

            return this.openActionPlansByAuditTemplate[String(auditTemplateId)] || 0
        },
        actionPlansBadge() {
            const actionPlansCount = this.openActionPlansCount

            if (!this.$store.getters['getShowRadarTool'] || actionPlansCount <= 0) {
                return null
            }

            return {
                icon: 'i-andy-circle-exclamation',
                label: actionPlansCount > 1 ? 'audit.action_plan_pl' : 'audit.action_plan_sg',
                value: actionPlansCount,
                textColor: '#cd902f',
                backgroundColor: '#faf4ea'
            }
        }
    },
    methods: {
        sendedId(id) {
            this.$emit('sendedId', id)
        },
        sendedAddedit(id) {
            this.$emit('sendedAddedit', id)
        }
    },
    filters: {
        moment: function (date) {
            return date ? moment(date).fromNow() : '--'
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.item {
    @include interaction();
    @include border-radius(8px);
    @include display-flex();
    @include align-items(stretch);
    background-color: #fff;
    width: calc((100% - 16px) / 2);
    height: auto;
    margin: 0;
    overflow: hidden;
    padding: 8px;
    position: relative;
    box-sizing: border-box;
    @include bgHover(#fff);
    .list {
        @include display-flex();
        @include flex-direction(column);
        flex: 1;
        gap: 8px;
        min-width: 0;
        width: 100%;
        padding: 0;
        .picture {
            @include border-radius(3px);
            @include background($color: $neutro-t50, $image: img('image_neutro.svg'), $size: 32px);
            flex-shrink: 0;
            height: 100px;
            width: 100%;
            margin: 0;
            object-fit: cover;
        }
        .name {
            @include display-flex();
            @include flex-direction(column);
            @include justify-content(center);
            align-self: stretch;
            flex: 1 0 40px;
            margin: 0;
            width: 100%;
            min-height: 40px;
            overflow: hidden;

            .name-text {
                @include font-size(sm);
                font-family: $text-bold;
                color: $main-s30;
                max-height: 40px;
                line-height: 20px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }
        }
        .subname {
            @include font-size(sm);
            height: auto;
            max-width: calc(100%);
            padding: 3px 0px;
            display: inline-block;
            .total {
                font-family: $text-bold;
            }
        }
        .progress {
            @include display-flex();
            @include align-items(flex-start);
            @include justify-content(flex-start);
            @include flex-wrap(wrap);
            gap: 8px;
            width: 100%;
            max-width: 100%;
            border-radius: 5px;
            margin-top: auto;
        }
    }
    // .nav {
    //     position: absolute;
    //     right: 0;
    //     width: 70px;
    //     height: 100%;
    //     @include background($image: img('right_dark.svg'), $position: center center, $size: 20px);
    // }
    &.portrait {
        width: 100%;
        margin: 0;

        .list {
            width: 100%;

            .name {
                @include font-size(sm);
                width: 100%;
                padding-left: unset;
                padding-right: unset;
            }
            .subname {
                @include font-size(xs);
            }
            .progress {
                @include font-size(xs);
            }
        }
    }
}
@include media('>tablet', '<desktop') {
    .item {
        width: calc((100% - 16px) / 2); // 1 gap * 16px
    }
}
@include media('<900px', '>650px') {
    .item {
        margin: 0;
        width: calc((100% - 16px) / 2) !important;
        .list {
            @include display-flex();
            @include flex-direction(column);
            height: 100%;
        }
    }
}
@include media('>=desktop') {
    .item {
        width: calc((100% - 32px) / 3); // 2 gaps * 16px
    }
}
</style>
